import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Checkbox,
  Col,
  Collapse,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Table,
  Tag,
  Upload,
  message,
} from "antd";
import { PlusOutlined, CopyOutlined, EyeOutlined } from "@ant-design/icons";

import { espacioBlanco, required } from "../../services/forms";
import http from "../../services/http";
import {
  confirm,
  modalError,
  modalSuccess,
} from "../../services/notifications";
import { actions, getToken, hasPermission } from "../../services/security";
import { BASEURL } from "../../services/url";
import "./Plantillas.scss";
import TextArea from "antd/lib/input/TextArea";
import ContentModal from "./Modal-content";
import Leyenda from "./Leyenda";

const PlantillasForm = (props) => {
  let navigate = useNavigate();
  const [form] = Form.useForm();
  const { id } = props;
  const Panel = Collapse.Panel;

  const [camposPlantilla, setCamposPlantilla] = useState([]);
  const [tablasPlantilla, setTablasPlantilla] = useState([]);
  const [modal, setModal] = useState([]);
  const [tablasModal, setTablasModal] = useState([]);
  const [datos, setDatos] = useState([]);
  const [estadoVariable, setEstadoVariable] = useState([]);
  const [codMasterDoc, setCodMasterDoc] = useState([]);
  const [camposTable, setCamposTable] = useState([]);
  const [plantillaTable, setPlantillaTable] = useState([]);
  // const [codMasterDocumentodos, setCodMasterDocumentodos] = useState([])
  const [tramitesAsociados, setTramitesAsociados] = useState([]);
  const [checkValueCampos, setCheckValueCampos] = useState([]);
  const [checkValueTablas, setCheckValueTablas] = useState([]);

  const [variableVisible, setVariableVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [base64, setBase64] = useState(null);
  const [bol, setBol] = useState(false);
  const [loading, setLoading] = useState(false);
  const [spiner, setSpiner] = useState(false);
  const [btnEspera, setBtnEspera] = useState(false);
  const [requiredFields, setRequiredFields] = useState([]); // Almacena referencias a los campos requeridos

  const disabled =
    id === "nuevo"
      ? !hasPermission(actions.PlantillaMasterDocCrear)
      : !hasPermission(actions.PlantillaMasterDocEditar);

  useEffect(() => {
    async function getForm() {
      let response = await http.get(`${BASEURL}/Parametry/EstadoVariable`);

      if (response) {
        let data = response.data;
        data = data.map((estado) => {
          return {
            id: estado.id,
            nombre: estado.nombre.replace(/([a-z])([A-Z])/g, "$1 $2"),
          };
        });
        setEstadoVariable(data);
      }

      setSpiner(true);
      // response = await http.get(`${BASEURL}/PlantillaMasterDoc/CodMasterDoc`);
      // if (response) {
      //   const data = response.data;
      //   setCodMasterDoc(data);
      //   setSpiner(false)
      // }
      response = await http.get(
        `${BASEURL}/PlantillaMasterDoc/CodMasterDoc/CodMasterTramite`
      );
      if (response) {
        const data = response.data;
        setCodMasterDoc(data);
        setSpiner(false);
      }

      if (id === "nuevo") {
        return;
      }

      response = await http.get(`${BASEURL}/PlantillaMasterDoc/${id}`);
      if (response) {
        const data = response.data;
        form.setFieldsValue(data);
      }
    }
    getForm();
  }, [id]);

  useEffect(() => {
    async function getDatos() {
      const campos = camposPlantilla.map((campo, index) => ({
        key: index,
        campoDiccionario:
          campo.campoDiccionario !== null ? campo.campoDiccionario : "-",
        nombre: campo.nombre === "" ? "Nombre No Definido" : campo.nombre,
        estadoVariable: campo.estadoVariable ? campo.estadoVariable : "-",
        tipoDeCampo: campo.tipoDeCampo ? campo.tipoDeCampo : "-",
        tipoDeEntrada: campo.tipoDeEntrada ? campo.tipoDeEntrada : "-",
        longitud: campo.longitud === 0 ? "Ilimitado" : campo.longitud,
      }));

      setCamposTable(campos);

      const camposTablas = tablasPlantilla.map((tabla, index) => ({
        key: index,
        nombreTabla: tabla.nombreTabla ? tabla.nombreTabla : "-",
        tablaDiccionario: tabla.tablaDiccionario ? tabla.tablaDiccionario : "-",
        estadoVariable: tabla.estadoVariable ? tabla.estadoVariable : "-",
        descripcion: tabla.descripcion ? tabla.descripcion : "-",
        cantidadFilas: tabla.cantidadFilas ? tabla.cantidadFilas : "-",
      }));

      setPlantillaTable(camposTablas);

      let camposValidos = camposPlantilla.map(
        (campo) => campo.estadoVariable === 1000
      );
      camposValidos.length > 0
        ? (camposValidos = camposValidos.every((estado) => estado))
        : (camposValidos = false);

      let camposTablasValidos = tablasPlantilla.map(
        (tabla) => tabla.estadoVariable === 1000
      );
      camposTablasValidos.length > 0
        ? (camposTablasValidos = camposTablasValidos.every((estado) => estado))
        : (camposTablasValidos = false);

      if (tablasPlantilla.length > 0) {
        if (camposValidos && camposTablasValidos) {
          setBol(true);
        } else {
          setBol(false);
        }
      } else if (tablasPlantilla.length == 0 && camposValidos) {
        setBol(true);
      } else {
        setBol(false);
      }
    }
    getDatos();
  }, [camposPlantilla, tablasPlantilla]);

  const onClickBack = () => {
    navigate("/plantillas");
  };

  const onClickSave = async (values) => {
    setLoading(true);

    let codMasterDocSelect = codMasterDoc.filter(
      (cod) => cod.codMasterDoc === values.codMasterDoc
    )[0];
    // let tramite = codMasterDoc.filter((cod, index) => cod.masterTramite === values.masterTramite).map((cod) => cod.masterTramite)[0]

    let campos = camposPlantilla.map((campo) => {
      return {
        nombre: campo.nombre,
        diccionarioId: campo.diccionarioId,
      };
    });

    let tablas = tablasPlantilla.map((tabla) => {
      return {
        nombreTabla: tabla.nombreTabla,
        diccionarioId: tabla.diccionarioId,
      };
    });

    // let jsonGuardar = {
    //   ...values,
    //   keepMacros: false,
    //   descripcionMasterDoc: selectedValues.descripcionMasterDoc,
    //   codMasterDoc: selectedValues.codMasterDoc,
    //   variables: {
    //     campos: [
    //       ...campos
    //     ],
    //     tables: [
    //       ...tablas
    //     ]
    //   },
    //   plantillaB64: base64,
    //   masterTramite: tramite,
    // }
    let jsonGuardar = {
      ...values,
      keepMacros: false,
      descripcionMasterDoc: codMasterDocSelect.descripcionMasterDoc,
      codMasterDoc: codMasterDocSelect.codMasterDoc,
      variables: {
        campos: [...campos],
        tables: [...tablas],
      },
      plantillaB64: base64,
      masterTramite: null,
    };

    let confirmed = await http.get(
      `${BASEURL}/PlantillaMasterDoc/Version/${codMasterDocSelect.codMasterDoc}`
    );

    if (confirmed) {
      let data = confirmed.data;
      if (data.version !== null) {
        confirmed = await confirm(
          "Se creará una nueva versión para esta plantilla",
          `Última version existente: ${data.version.replace("_", " ")} `
        );
      }
      if (!confirmed) {
        setLoading(false);
        return;
      }
    }

    const MAX_RETRIES = 2; // Número máximo de intentos (puedes ajustarlo según tus necesidades)
    let retries = 0; // Contador de intentos
    let response;
    while (retries < MAX_RETRIES) {
      try {
        response = await http.post(
          `${BASEURL}/PlantillaMasterDoc`,
          jsonGuardar
        );
        break; // Sal del bucle si la solicitud tiene éxito
      } catch (error) {
        if (error.response && error.response.status) {
          modalError(
            error.response.data.errores[0].titulo,
            error.response.data.errores[0].detalle
          );
        }
        retries++; // Incrementa el contador de intentos
      }
    }

    setLoading(false);

    if (response) {
      await modalSuccess(
        "Plantilla guardada",
        id === "nuevo"
          ? "La plantilla fue creada exitosamente"
          : "La plantilla fue modificada exitosamente"
      );
      navigate("/plantillas");
    }
  };

  const uploadImage = async (options) => {
    const { onSuccess, onError, file } = options;
    // const formData = new FormData();

    form.setFieldValue("nombreArchivo", file.name);

    const toBase64 = (file) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.split(",")[1]);
        reader.onerror = (error) => reject(error);
      });

    const base64 = await toBase64(file);

    setBase64(base64);

    const uploadResponse = await http
      .post(`${BASEURL}/PlantillaMasterDoc/procesar`, {
        plantillaB64: base64,
        codBanco: localStorage.getItem("banco"),
      })
      .catch((error) => {
        if (error.response.status) {
          modalError(
            error.response.data.errores[0].titulo,
            error.response.data.errores[0].detalle
          );
          onError("error");
        }
      });

    if (uploadResponse) {
      const data = uploadResponse.data;
      setDatos(data);
      setCamposPlantilla(data.camposPlantilla);
      setTablasPlantilla(data.tablasPlantilla);
      onSuccess("ok");
    } else {
      onError("error");
    }
  };

  const props2 = {
    multiple: false,
    accept: ".docx,.dotx,.doc",
    listType: "picture",
    customRequest: uploadImage,
    maxCount: 1,
    onRemove: () => {
      setCamposPlantilla([]);
      setTablasPlantilla([]);
      form.setFieldValue("nombreArchivo", "");
      setBol(false);
    },
  };

  const colorTag = (id) => {
    switch (id) {
      case 1000:
        return "green";
      case 1001:
        return "yellow";
      case 1002:
        return "red";
      case 1003:
        return "orange";
      default:
        return "black";
    }
  };

  const columnasCampos = [
    {
      title: "Nombre",
      dataIndex: "nombre",
      key: "nombre",
    },
    {
      title: "Variable Diccionario",
      dataIndex: "campoDiccionario",
      key: "campoDiccionario",
      render: (text, record) => {
        let campo = record;
        if (campo.campoDiccionario) {
          if (
            campo.campoDiccionario === null ||
            campo.campoDiccionario === "-"
          ) {
            return "-";
          } else {
            return campo.campoDiccionario.nombre;
          }
        }
      },
    },
    {
      title: "Coincidencia",
      dataIndex: "estadoVariable",
      key: "estadoVariable",
      render: (id) => {
        let estado = estadoVariable.find((estado) => estado.id === id);
        return estado ? (
          <Tag color={colorTag(estado.id)}>{estado.nombre}</Tag>
        ) : null;
      },
      sorter: (a, b) => a.estadoVariable - b.estadoVariable,
      defaultSortOrder: "descend",
    },
    {
      title: "Longitud",
      dataIndex: "longitud",
      key: "longitud",
    },
    {
      title: "Tipo Campo",
      dataIndex: "tipoDeCampo",
      key: "tipoDeCampo",
      render: (text, record) => {
        let tipo = record;
        if (tipo.tipoDeCampo) {
          return tipo.tipoDeCampo.nombre;
        }
      },
    },
    {
      title: "Tipo de Dato",
      dataIndex: "tipoDeEntrada",
      key: "tipoDeEntrada",
      render: (text, record) => {
        let tipo = record;
        if (tipo.tipoDeEntrada) {
          return tipo.tipoDeEntrada.nombre;
        }
      },
    },
    {
      title: "Es local",
      dataIndex: "esLocal",
      key: "esLocal",
      render: (text, record) => (
        <Space className="" size="middle">
          {record.estadoVariable !== 1000 &&
            record.nombre !== "Nombre No Definido" &&
            record.estadoVariable !== 1003 && (
              <Checkbox onChange={(e) => onCheckValue(e, record.key, 0)} />
            )}

          {(record.estadoVariable === 1000 ||
            record.nombre === "Nombre No Definido" ||
            record.estadoVariable === 1003) &&
            "-"}
        </Space>
      ),
    },
    {
      title: "Acciones",
      dataIndex: "acciones",
      key: "acciones",
      render: (text, record) => (
        <Space className="btn-container" size="middle">
          {record.estadoVariable !== 1000 &&
            record.nombre !== "Nombre No Definido" &&
            record.estadoVariable !== 1003 && (
              <Button
                disabled={btnEspera}
                className="btn-action"
                title="Agregar Variable"
                type="quaternary"
                color="green"
                shape="circle"
                size="large"
                icon={<PlusOutlined />}
                onClick={() => handleAgregarCampos(record.key)}
              ></Button>
            )}

          {record.estadoVariable !== 1000 &&
            record.estadoVariable !== 1002 &&
            record.estadoVariable !== 1003 && (
              <Button
                className="btn-action"
                title="Copiar al Portapapeles"
                icon={<CopyOutlined />}
                shape="circle"
                size="large"
                onClick={() => handleCopiar(record.key)}
              ></Button>
            )}

          <Button
            className="btn-action"
            title="Ver Detalle"
            type="tertiary"
            shape="circle"
            size="large"
            icon={<EyeOutlined />}
            onClick={() => handleModal({ id: record.key, tipo: 0 })}
          ></Button>
        </Space>
      ),
    },
  ];

  const columnasTablas = [
    {
      title: "Nombre",
      dataIndex: "nombreTabla",
      key: "nombreTabla",
    },
    {
      title: "Variable Diccionario",
      dataIndex: "tablaDiccionario",
      key: "tablaDiccionario",
      render: (text, record) => {
        let tabla = record;
        if (tabla.tablaDiccionario !== "-") {
          return tabla.tablaDiccionario.nombreTabla;
        } else {
          return tabla.tablaDiccionario;
        }
      },
    },
    {
      title: "Coincidencia",
      dataIndex: "estadoVariable",
      key: "estadoVariable",
      render: (id) => {
        let estado = estadoVariable.find((estado) => estado.id === id);
        return estado ? (
          <Tag color={colorTag(estado.id)}>{estado.nombre}</Tag>
        ) : null;
      },
      sorter: (a, b) => a.estadoVariable - b.estadoVariable,
      defaultSortOrder: "descend",
    },
    {
      title: "Descripción",
      dataIndex: "descripcion",
      key: "descripcion",
    },
    {
      title: "Filas",
      dataIndex: "cantidadFilas",
      key: "cantidadFilas",
    },
    {
      title: "Es local",
      dataIndex: "esLocal",
      key: "esLocal",
      render: (text, record) => (
        <Space className="" size="middle">
          {record.estadoVariable !== 1000 &&
            record.nombre !== "Nombre No Definido" &&
            record.estadoVariable !== 1003 && (
              <Checkbox onChange={(e) => onCheckValue(e, record.key, 1)} />
            )}

          {(record.estadoVariable === 1000 ||
            record.nombre === "Nombre No Definido" ||
            record.estadoVariable === 1003) &&
            "-"}
        </Space>
      ),
    },
    {
      title: "Acciones",
      dataIndex: "acciones",
      key: "acciones",
      render: (text, record) => (
        <Space className="btn-container" size="middle">
          {record.estadoVariable !== 1000 && record.estadoVariable !== 1003 && (
            <Button
              disabled={btnEspera}
              className="btn-action"
              title="Agregar Variable"
              type="quaternary"
              color="green"
              shape="circle"
              size="large"
              icon={<PlusOutlined />}
              onClick={() => handleAgregarCamposTabla(record.key)}
            ></Button>
          )}

          {record.estadoVariable !== 1000 &&
            record.estadoVariable !== 1002 &&
            record.estadoVariable !== 1003 && (
              <Button
                className="btn-action"
                title="Copiar al Portapapeles"
                icon={<CopyOutlined />}
                shape="circle"
                size="large"
                onClick={() => handleCopiarPlantilla(record.key)}
              ></Button>
            )}

          <Button
            className="btn-action"
            title="Ver Detalle"
            type="tertiary"
            shape="circle"
            size="large"
            icon={<EyeOutlined />}
            onClick={() => handleModal({ id: record.key, tipo: 1 })}
          ></Button>
        </Space>
      ),
    },
  ];

  const onCheckValue = (value, key, tipo) => {
    value = value.target.checked;

    tipo === 0
      ? setCheckValueCampos((prevValuesChecked) => {
          const updateCheckedValidate = [...prevValuesChecked];

          const index = updateCheckedValidate.findIndex(
            (obj) => obj.idCheck === key
          );

          if (index !== -1) {
            updateCheckedValidate[index] = {
              ...updateCheckedValidate[index],
              checkValidate: value,
            };
          } else {
            updateCheckedValidate.push({
              checkValidate: value,
              idCheck: key,
            });
          }
          return updateCheckedValidate;
        })
      : setCheckValueTablas((prevValuesChecked) => {
          const updateCheckedValidate = [...prevValuesChecked];

          const index = updateCheckedValidate.findIndex(
            (obj) => obj.idCheck === key
          );

          if (index !== -1) {
            updateCheckedValidate[index] = {
              ...updateCheckedValidate[index],
              checkValidate: value,
            };
          } else {
            updateCheckedValidate.push({
              checkValidate: value,
              idCheck: key,
            });
          }
          return updateCheckedValidate;
        });
  };

  const handleAgregarCampos = async (id) => {
    // Lógica para agregar el registro con el id correspondiente.
    setBtnEspera(true);
    let codigoBancoCheck = checkValueCampos
      .filter((checkObj) => checkObj.idCheck === id)
      .map((obj) => obj.checkValidate);

    try {
      const agregar = camposPlantilla
        .filter((campo, index) => index === id)
        .map((campo) => {
          return {
            nombre: campo.nombre,
            codBanco: codigoBancoCheck[0]
              ? localStorage.getItem("banco")
              : "COR",
            longitud: campo.longitud,
            tipoDeCampo: campo.tipoDeCampo.id,
            tipoDeEntrada: campo.tipoDeEntrada.id,
            formatoDeEntrada: campo.formatoDeEntrada.id,
            caracterDeRelleno: campo.caracterDeRelleno,
            opciones: campo.opciones,
            descripcion: campo.descripcion,
            textoPorDefecto: campo.textoPorDefecto,
            cantidadFilas: campo.cantidadFilas ? campo.cantidadFilas : null,
          };
        });
      let response = await http
        .post(`${BASEURL}/Diccionario`, agregar[0])
        .catch((error) => {
          message.error(error.response.data.detalle);
          setBtnEspera(false);
        });

      if (response) {
        let data = response.data;
        camposTable[id].estadoVariable = 1000;
        camposTable[id].diccionarioId = data.id;

        let campoUpdate = camposPlantilla.map((campo, index) => {
          if (agregar[0].nombre === campo.nombre) {
            return {
              ...campo,
              estadoVariable: 1000,
              diccionarioId: data.id,
            };
          } else {
            return campo;
          }
        });
        setCamposPlantilla(campoUpdate);
        message.success("Se agrego el registro correctamente");
      }
    } catch (error) {
      message.error(error.response.data.detalle);
    }
    setBtnEspera(false);
  };

  const handleAgregarCamposTabla = async (id) => {
    setBtnEspera(true);
    let codigoBancoCheck = checkValueTablas
      .filter((checkObj) => checkObj.idCheck === id)
      .map((obj) => obj.checkValidate);

    try {
      const agregar = tablasPlantilla
        .filter((campo, index) => index === id)
        .map((campoTable) => {
          return {
            nombre: campoTable.nombreTabla ? campoTable.nombreTabla : null,
            codBanco: codigoBancoCheck[0]
              ? localStorage.getItem("banco")
              : "COR",
            longitud: campoTable.longitud ? campoTable.longitud : null,
            tipoDeCampo: campoTable.tipoDeCampo.id
              ? campoTable.tipoDeCampo.id
              : null,
            tipoDeEntrada: campoTable.tipoDeEntrada
              ? campoTable.tipoDeEntrada
              : null,
            formatoDeEntrada: campoTable.formatoDeEntrada
              ? campoTable.formatoDeEntrada
              : null,
            caracterDeRelleno: campoTable.caracterDeRelleno
              ? campoTable.caracterDeRelleno
              : null,
            opciones: campoTable.opciones ? campoTable.opciones : [],
            descripcion: campoTable.descripcion ? campoTable.descripcion : null,
            textoPorDefecto: campoTable.textoPorDefecto
              ? campoTable.textoPorDefecto
              : null,
            cantidadFilas: campoTable.cantidadFilas
              ? campoTable.cantidadFilas
              : null,
            definicionColumna: campoTable.columnas ? campoTable.columnas : [],
          };
        });
      let response = await http
        .post(`${BASEURL}/Diccionario`, agregar[0])
        .catch((error) => {
          message.error(error.response.data.errores[0].detalle);
          setBtnEspera(false);
        });

      if (response) {
        let data = response.data;
        plantillaTable[id].estadoVariable = 1000;
        plantillaTable[id].diccionarioId = data.id;

        let tablaUpdate = tablasPlantilla.map((tabla, index) => {
          if (agregar[0].nombre === tabla.nombreTabla) {
            return {
              ...tabla,
              estadoVariable: 1000,
              diccionarioId: data.id,
            };
          } else {
            return tabla;
          }
        });
        setTablasPlantilla(tablaUpdate);
        message.success("Se agrego el registro correctamente");
      }
    } catch (error) {
      message.error(error.response.data.detalle);
    }
    setBtnEspera(false);
  };

  const handleCopiar = (id) => {
    // Lógica para copiar el registro con el id correspondiente al portapapeles.
    const copiar = camposPlantilla.find((campo, index) => index === id);

    const copyToClipboard = (str) => {
      const el = document.createElement("textarea");
      el.value = str;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      const selected =
        document.getSelection().rangeCount > 0
          ? document.getSelection().getRangeAt(0)
          : false;
      el.select();
      document.execCommand("copy");
      message.success("¡Copiado al portapapeles!");
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
    };
    copyToClipboard(copiar.campoDiccionario.nombre);
  };

  const handleCopiarPlantilla = (id) => {
    // Lógica para copiar el registro con el id correspondiente al portapapeles.
    const copiar = tablasPlantilla.find((campo, index) => index === id);

    const copyToClipboard = (str) => {
      const el = document.createElement("textarea");
      el.value = str;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      const selected =
        document.getSelection().rangeCount > 0
          ? document.getSelection().getRangeAt(0)
          : false;
      el.select();
      document.execCommand("copy");
      message.success("¡Copiado al portapapeles!");
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
    };
    copyToClipboard(copiar.tablaDiccionario.nombreTabla);
  };

  const handleModal = (values) => {
    const { id, tipo } = values;
    // Lógica para mostrar un modal con información de registro con el id correspondiente.
    let tipoCampos = camposPlantilla;
    let tipoTablas = tablasPlantilla;

    const generateId = () => {
      return Math.random().toString(36).substr(2, 9);
    };

    if (tipo === 0) {
      tipoCampos = tipoCampos
        .filter((campo, index) => (index === id ? campo : null))
        .map((campo) => ({
          id: generateId(),
          nombre: campo.nombre,
          longitud: campo.longitud === 0 ? "Ilimitado" : campo.longitud,
          tipoDeCampo: campo.tipoDeCampo,
          tipoDeEntrada: campo.tipoDeEntrada,
          formatoDeEntrada: campo.formatoDeEntrada,
          caracterDeRelleno: campo.caracterDeRelleno,
          opciones: campo.opciones.length === 0 ? null : campo.opciones,
          descripcion: campo.descripcion,
          textoPorDefecto: campo.textoPorDefecto,
          tipo: tipo,
          campoDiccionario: campo.campoDiccionario
            ? { ...campo.campoDiccionario, id: generateId() }
            : null,
        }));
      setModal(tipoCampos);
      setModalVisible(true);
    } else if (tipo === 1) {
      tipoTablas = tipoTablas
        .filter((tabla, index) => (index === id ? tabla : null))
        .map((tabla, index) => ({
          id: generateId(),
          nombreTabla: tabla.nombreTabla,
          descripcion: tabla.descripcion,
          cantidadFilas: tabla.cantidadFilas,
          columnas: tabla.columnas,
          tipo: tipo,
          tablasDiccionario: tabla.tablaDiccionario
            ? { ...tabla.tablaDiccionario, id: generateId() }
            : null,
        }));
      setModal(tipoTablas);
      setTablasModal(tipoTablas);
      setModalVisible(true);
    }
  };

  const pagination = {
    defaultPageSize: 20,
    pageSizeOptions: ["20", "40", "60"],
    showSizeChanger: true,
    locale: { items_per_page: "" },
  };

  const handleCancel = () => {
    setModalVisible(false);
    setModal([]);
  };

  // const onChangeMasterDoc = (value, option) => {

  //   const selectedValue2 = option?.values2;

  //   if (selectedValue2 === undefined) {
  //     form.resetFields(['descripcionMasterDoc'])
  //     setCodMasterDocumentodos([])
  //   }
  //   else {
  //     codMasterDoc.map((codMasterDoc, index) => {
  //       if (index === selectedValue2) {
  //         form.resetFields(['descripcionMasterDoc'])
  //         setCodMasterDocumentodos(codMasterDoc.documentos)
  //       }
  //     })
  //   }
  // }

  // const handleSelectChange = (value, option) => {
  //   const selectedValue = option?.values2;

  //   if (selectedValue !== undefined) {
  //     codMasterDocumentodos.map((campos, index) => {
  //       if (index === selectedValue) {
  //         setSelectedValues({
  //           descripcionMasterDoc: campos.descripcionMasterDoc,
  //           codMasterDoc: campos.codMasterDoc
  //         });
  //       }
  //     })
  //   }
  //   else {
  //     setSelectedValues({
  //       descripcionMasterDoc: '',
  //       codMasterDoc: ''
  //     });
  //   }

  // };

  const onChange = (value, option) => {
    if (value) {
      const tramitesFormatted = option.tramites
        .map((tramite) => `{ ${tramite.masterTramite} }\n`)
        .join("\n");

      form.setFieldsValue({
        tramitesAsociados: tramitesFormatted,
      });
    }

    if (value === undefined) {
      form.resetFields(["tramitesAsociados"]);
    }
  };

  const onFinishFailed = () => {
    message.error("Se deben completar los campos requeridos");
  };

  return (
    <Form
      layout="vertical"
      form={form}
      onFinish={onClickSave}
      onFinishFailed={onFinishFailed}
    >
      <Row gutter={16}>
        {/* <Col xs={24}>
          <Form.Item label="Tramite LD" name="masterTramite" rules={[required]}>
            <Select
              loading={spiner}
              allowClear
              showSearch
              maxTagCount="responsive"
              placeholder="Seleccione un Master Doc"
              onChange={onChangeMasterDoc}
              options={
                codMasterDoc.map((codMasterDoc, index) => ({
                  value: codMasterDoc.masterTramite,
                  values2: index,
                  label: codMasterDoc.masterTramite,
                  key: index
                }))

              }
            >
              {codMasterDoc.map((masterDoc, index) => (
                <Select.Option key={index}>
                  {masterDoc.masterTramite}
                </Select.Option>
              ))}
            </Select>

          </Form.Item>
        </Col> */}

        {/* <Col xs={24}>
          <Form.Item label="Documento" name="descripcionMasterDoc" rules={[required]}>
            <Select
              allowClear
              showSearch
              maxTagCount="responsive"
              options={
                codMasterDocumentodos.map((documento, index) => ({
                  value: documento.nombre,
                  values2: index,
                  label: documento.nombre,
                  disabled: documento.codMasterDocVacio,
                  key: index
                }))
              }
              onChange={handleSelectChange}
            >
              {codMasterDocumentodos.map((documento, index) => (
                <Select.Option key={index} value={documento.codMasterDoc}>
                  {documento.nombre}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col> */}

        <Col xs={24}>
          <Form.Item label="Documento" name="codMasterDoc" rules={[required]}>
            <Select
              allowClear
              showSearch
              maxTagCount="responsive"
              onChange={onChange}
              options={codMasterDoc.map((documento, index) => ({
                value: documento.codMasterDoc,
                label: documento.nombre,
                disabled: documento.codMasterDocVacio,
                tramites: documento.tramites,
                key: index,
              }))}
            >
              {/* {codMasterDoc.map((documento, index) => (
                <Select.Option key={index}>
                  {documento.nombre}
                </Select.Option>
              ))} */}
            </Select>
          </Form.Item>
        </Col>

        <Col xs={24}>
          <Form.Item
            label="Tramites Asociados"
            name="tramitesAsociados"
          >
            <Input.TextArea
              disabled={true}
              autoComplete="off"
              autoSize={{ minRows: 3, maxRows: 6 }}
            />
          </Form.Item>
        </Col>

        <Col xs={24}>
          <Form.Item label="Descripción" name="descripcion" rules={[required]}>
            <TextArea rows={2} autoComplete="off" disabled={disabled} />
          </Form.Item>
        </Col>

        <Col style={{ display: "none" }} xs={24}>
          <Form.Item
            label="Nombre archivo"
            name="nombreArchivo"
            rules={[required, espacioBlanco]}
          >
            <Input autoComplete="off" disabled={true} />
          </Form.Item>
        </Col>

        <Col xs={24}>
          <Upload className="upload" {...props2}>
            <Button>Cargar archivo</Button>
          </Upload>
        </Col>

        <Col xs={12}>
          <Button
            className="btn-leyenda"
            type="tertiary"
            onClick={() => {
              setVariableVisible(true);
            }}
          >
            Ayuda
          </Button>
        </Col>

        <Modal
          className="modal-leyenda"
          title="Ayuda"
          open={variableVisible}
          onCancel={() => {
            setVariableVisible(false);
          }}
          footer={[
            <Button
              key="cerrar"
              onClick={() => {
                setVariableVisible(false);
              }}
            >
              Cerrar
            </Button>,
          ]}
          width={1000}
        >
          <Leyenda />
        </Modal>

        {camposTable && camposTable.length > 0 && (
          <Collapse className="collapse" defaultActiveKey={["1"]}>
            <Panel className="panel" header="Campos" key="1">
              <Table
                className="table"
                columns={columnasCampos}
                key={camposTable.map((campo) => campo.key)}
                dataSource={camposTable}
                pagination={pagination}
                rowClassName={(record, index) =>
                  index % 2 === 0 ? "even-row" : "odd-row"
                }
              />
            </Panel>
          </Collapse>
        )}

        {plantillaTable && plantillaTable.length > 0 && (
          <Collapse className="collapse" defaultActiveKey={["1"]}>
            <Panel className="panel" header="Tablas" key="1">
              <Table
                className="table"
                columns={columnasTablas}
                key={plantillaTable.map((tabla) => tabla.key)}
                dataSource={plantillaTable}
                pagination={pagination}
                rowClassName={(record, index) =>
                  index % 2 === 0 ? "even-row" : "odd-row"
                }
              />
            </Panel>
          </Collapse>
        )}
      </Row>
      <Modal
        className="modal"
        title="Detalle"
        open={modalVisible}
        onCancel={() => {
          handleCancel();
        }}
        footer={[
          <Button
            key="cerrar"
            onClick={() => {
              handleCancel();
            }}
          >
            Cerrar
          </Button>,
        ]}
        width={1000}
      >
        {modal.map((item, index) => (
          <ContentModal
            key={index}
            tipo={item.tipo}
            item={item}
            tablas={tablasModal[0]}
          />
        ))}
      </Modal>

      <div className="actions">
        <Button type="text" onClick={onClickBack}>
          Volver
        </Button>
        {!disabled &&
          (bol ? (
            <Button type="primary" htmlType="submit" loading={loading}>
              {!loading && "Guardar"}
            </Button>
          ) : null)}
      </div>
    </Form>
  );
};

export default PlantillasForm;
